import type { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';

import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { NavigationMenuService } from '@commons/navigation-menu/navigation-menu.service';
import { Store as NgrxStore } from '@ngrx/store';
import { NotificationsService, NotifStatus } from '@wizbii-components/bo-angular-ui';
import { isLogged, roles } from '@wizbii-utils/angular/stores';
import { filter, first, map, switchMap } from 'rxjs/operators';

export const mustHaveRoleGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const store = inject(NgrxStore);
  const notificationsService = inject(NotificationsService);
  const layoutMenuService = inject(NavigationMenuService);
  const router = inject(Router);

  return store.select(isLogged).pipe(
    filter((isLogged) => !!isLogged),
    first(),
    switchMap(() => store.select(roles)),
    map((roles) => {
      if (!roles?.includes(route.data.role)) {
        notificationsService.createToast(
          `Vous n'avez pas les droits nécessaires pour accéder à cette page.`,
          NotifStatus.Info,
          3000
        );
        return router.createUrlTree([layoutMenuService.getFirstGrantedItemRoute(roles ?? [])]);
      }
      return true;
    })
  );
};
